module.exports = __webpack_public_path__ + "img/logo.5ffcc4ac.png";